import { Component } from '@angular/core';

/**
 * Overlay GLOBAL de loading — CONFIRMADO no app real (24/08/2026, tenant
 * conectaplan) como sendo a biblioteca `ngx-spinner` (ver
 * loader.component.html), não um componente próprio. `LoaderService`
 * (core/services/loader) chama `NgxSpinnerService.show()/hide()` por baixo,
 * então este componente não precisa de estado próprio — só hospeda o
 * `<ngx-spinner>` no template (ver app.component.html).
 */
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {}
